module.exports = __webpack_public_path__ + "static/media/knife-kitchen.e3addc4b.svg";